import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { isIntegrationGrantedByPermissions } from '@/lib/integrationPermissions';

interface IntegrationRouteProps {
  entitlementKey: string;
  children: React.ReactNode;
  fallback?: string;
}

// Blocks direct URL access to a specific integration page (e.g. /home/payu)
// when the team member's per-user permissions don't grant that integration.
// Plan-level entitlements are still enforced separately by FeatureRoute on
// the parent `integrations` feature key.
export function IntegrationRoute({
  entitlementKey,
  children,
  fallback = '/home/integrations',
}: IntegrationRouteProps) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/auth" replace />;

  const menu_permissions = (user as any)?.menu_permissions;
  if (!isIntegrationGrantedByPermissions({ menu_permissions, entitlementKey })) {
    return <Navigate to={fallback} replace />;
  }
  return <>{children}</>;
}
